<template>
  <section class="section section-shaped section-lg my-0">
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-5"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
            <template>
              <div class="text-muted text-center mb-12">
                <h5 style="padding-bottom: 20px">Contacto</h5>
              </div>
              <div class="text-center" v-if="loading">
                <img style="max-height: 70px;" v-bind:src="'./img/custom/loading.svg'" />Loading...
              </div>
            </template>
            <template>
              <form id="registro" @submit.prevent="validateForm">
                <div class="row">
                  <div class="col-12" v-if="errors.length">
                    <div>
                      <base-alert type="default">
                        <span class="alert-inner--icon">
                          <i class="ni ni-bell-55"></i>
                        </span>
                        <span class="alert-inner--text">
                          <ul style="margin: 0px;">
                            <li v-for="error of errors" v-bind:key="error">{{ error }}</li>
                          </ul>
                        </span>
                      </base-alert>
                    </div>
                  </div>
                  
                  <div
                    class="col-12"
                    role="form"
                  >
                    <div class="row">
                      <div class="col-lg-6 col-ls-12">
                        <base-input
                          alternative
                          class="mb-3"
                          placeholder="Nombres"
                          v-model="user.first_name"
                        ></base-input>
                      </div>
                      <div class="col-lg-6 col-ls-12">
                        <base-input
                          alternative
                          class="mb-3"
                          placeholder="Apellidos"
                          v-model="user.last_name"
                        ></base-input>
                      </div>
                      <div class="col-lg-6 col-ls-12">
                        <select class="form-control" v-model="user.identification_type">
                            <option value="" selected disabled>Tipo de identificación</option>
                            <option v-for="identification_type in identification_types" v-bind:key="identification_type">{{identification_type}}</option>
                        </select>
                      </div>
                      <div class="col-lg-6 col-ls-12">
                        <base-input
                          alternative
                          class="mb-3"
                          placeholder="Documento de identificación"
                          v-model="user.identification_number"
                        ></base-input>
                      </div>
                      <div class="col-lg-6 col-ls-12">
                        <base-input
                          alternative
                          class="mb-3"
                          type="email"
                          placeholder="Correo electrónico"
                          v-model="user.email"
                        ></base-input>
                      </div>
                      <div class="col-lg-6 col-ls-12">
                        <base-input
                          alternative
                          class="mb-3"
                          placeholder="Teléfono"
                          v-model="user.phone"
                        ></base-input>
                      </div>
                      <div class="col-lg-12 col-ls-12">
                          <textarea 
                          class="form-control" 
                          rows="3" 
                          placeholder="Descripción..."
                          v-model="user.description"
                          ></textarea>
                      </div>
                      
                    </div>
                    <div class="text-center">
                      <base-button 
                      nativeType="submit" 
                      type="primary" 
                      class="my-4"
                      :disabled="loading"
                      >
                      <span v-if="!loading">Enviar</span>
                      <span v-if="loading">Enviando...</span>
                      </base-button>
                    </div>
                  </div>
                </div>
              </form>
            </template>
            <template>
              
            </template>
          </card>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
const AmazonCognitoIdentity = require("amazon-cognito-identity-js");
const axios = require("axios");
const moment = require("moment");

import Modal from "@/components/Modal.vue";


export default {
  data() {
    return {
      modals: {
        modal0: false
      },
      title: "Holi",
      errors: [],
      loading: false,
      sectors: [
        {
          id: 1,
          name: "Comuna 1 - Popular"
        },
        {
          id: 2,
          name: "Comuna 2 - Santa Cruz"
        },
        {
          id: 3,
          name: "Comuna 3 - Manrique"
        },
        {
          id: 4,
          name: "Comuna 4 - Aranjuez"
        },
        {
          id: 5,
          name: "Comuna 5 - Castilla"
        },
        {
          id: 6,
          name: "Comuna 6 - Doce de Octubre"
        },
        {
          id: 7,
          name: "Comuna 7 - Robledo"
        },
        {
          id: 8,
          name: "Comuna 8 - Villa Hermosa"
        },
        {
          id: 9,
          name: "Comuna 9 - Buenos Aires"
        },
        {
          id: 10,
          name: "Comuna 10 - La Candelaria"
        },
        {
          id: 11,
          name: "Comuna 11 - Laureles Estadio"
        },
        {
          id: 12,
          name: "Comuna 12 - La América"
        },
        {
          id: 13,
          name: "Comuna 13 - San Javier"
        },
        {
          id: 14,
          name: "Comuna 14 - El Poblado"
        },
        {
          id: 15,
          name: "Comuna 15 - Guayabal"
        },
        {
          id: 16,
          name: "Comuna 16 - Belén"
        },
        {
          id: 50,
          name: "Comuna 50 - Corregimiento de San Sebastián de Palmitas"
        },
        {
          id: 60,
          name: "Comuna 60 - Corregimiento de San Cristóbal"
        },
        {
          id: 70,
          name: "Comuna 70 - Corregimiento de Altavista"
        },
        {
          id: 80,
          name: "Comuna 80 - Corregimiento de San Antonio de Prado"
        },
        {
          id: 90,
          name: "Comuna 90 - Corregimiento de Santa Elena"
        },
        {
          id: 100,
          name: "Otro municipio"
        }
      ],
      identification_types: [
        "Cédula",
        "Pasaporte",
        "Registro de Nacimiento",
        "Tarjeta de Identidad"
      ],
      user: {
        first_name: "",
        last_name: "",
        identification_type: "",
        identification_number: "",
        email: "",
        phone: "",
        description: ""
      },
      form_cleaned: {
        first_name: "",
        last_name: "",
        identification_type: "",
        identification_number: "",
        email: "",
        phone: "",
        description: ""
      }
    };
  },
  components: {
  },
  methods: {
    async validateForm(){
      this.errors = [];

      // Required
      if(!this.user.identification_number)
        this.errors.push("El número de identificación es obligatorio");
      if(!this.user.first_name)
        this.errors.push("El nombre es obligatorio");
      if(!this.user.last_name)
        this.errors.push("El apellido es obligatorio");
      if(!this.user.identification_type)
        this.errors.push("El tipo de identificación es obligatorio");
      if(!this.user.email)
        this.errors.push("El correo electrónico es obligatorio");
      if(!this.user.description)
        this.errors.push("Por campo descripción es obligatorio");
      if(this.errors.length){
        return false;
      }

      if(!/^[0-9a-zA-Z_]{1,16}$/.test(this.user.identification_number))
        this.errors.push("El número de identificación es incorrecto");

      if(!/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(this.user.email))
        this.errors.push("El correo electrónico es incorrecto");

      if (this.errors.length) {
        return false;
      } else {
        return this.sendRequest();
      }
    },
    async sendRequest() {
      this.loading = true;
      var user = this.user;

      try{
        let response = await axios.post(this.$store.state.api_url+'contact', this.user);
        if(response.data == true){
          alert('Gracias por comunicarse con nosotros, pronto daremos respuesta a su solicitud');
          this.user = this.form_cleaned;
        }else{
          this.errors.push("Ocurrió un error al intentar enviar su solicitud");
        }
      }catch(err){
        this.errors.push("Ocurrió un error al intentar enviar su solicitud");
      }

      this.loading = false;
    }
  }
};
</script>
<style>
</style>
